import { isAnyOf } from '@reduxjs/toolkit';

import ooeConstants from '../constants';
import { AppStartListening } from '../listenerMiddleware';
import { logEvent } from '../services/analytics';
import { ThunkPendingAction } from '../types/store';
import { actions as userActions } from '../user/reducer';
import { getUserLocations } from '../user/thunks';
import { submitOrder } from '../order/thunks';
import { actions as dashboardActions } from './reducer';
import {
  cancelOrder,
  getAdditionalPastOrders,
  getOrdersForSpecificDays,
  getRecentAndUpcomingOrders,
  lookupOrderDetails,
  lookupPosOrderDetails,
  resendPaymentEmail,
} from './thunks';

const addDashboardListeners = (startListening: AppStartListening) => {
  startListening({
    actionCreator: userActions.updateUserLocation,
    effect: (_, listenerApi) => {
      const { dispatch } = listenerApi;
      dispatch(dashboardActions.loadingOrders());
    },
  });

  startListening({
    actionCreator: getUserLocations.fulfilled,
    effect: (_, listenerApi) => {
      const { dispatch } = listenerApi;
      dispatch(dashboardActions.loadingOrders());
    },
  });

  startListening({
    matcher: isAnyOf(
      getRecentAndUpcomingOrders.pending,
      getAdditionalPastOrders.pending,
      getOrdersForSpecificDays.pending,
      cancelOrder.pending,
      lookupPosOrderDetails.pending,
      lookupOrderDetails.pending,
      resendPaymentEmail.pending,
    ),
    effect: (action) => {
      const {
        type,
        meta: { arg },
      } = action as ThunkPendingAction;
      logEvent(type, arg);
    },
  });

  startListening({
    matcher: isAnyOf(userActions.updateUserLocation, getUserLocations.fulfilled, submitOrder.fulfilled),
    effect: async (action, listenerApi) => {
      const { dispatch, cancelActiveListeners, delay, extra } = listenerApi;

      // debounce (https://redux-toolkit.js.org/api/createListenerMiddleware#complex-async-workflows)
      cancelActiveListeners();
      await delay(ooeConstants.DXE_DASHBOARD_DELAY_TIME);

      if (extra.testUtils?.debounceCallback) {
        extra.testUtils.debounceCallback(action);
      }

      dispatch(getRecentAndUpcomingOrders());
    },
  });
};

export default addDashboardListeners;
